import { ApisClient } from "@dpdgroupuk/mydpd-app";

export default new ApisClient({
  fallbackBaseUrl: process.env.REACT_APP_API_URL,
});
